module.exports = __webpack_public_path__ + "img/1f994.dcb1451.svg";